import { Box, IconButton } from "@mui/material";
import React from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Link as Scroll } from "react-scroll";

const ScrollToTop = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Scroll to="home" smooth>
        <IconButton
          sx={{
            backgroundColor: "primary.light",
            color: "#FFF",
            "&:hover": { backgroundColor: "secondary.main" },
            //  "&:focus": { backgroundColor: "secondary.light" },
          }}
        >
          <ExpandLessIcon sx={{ width: "30px", height: "30px" }} />
        </IconButton>
      </Scroll>
    </Box>
  );
};

export default ScrollToTop;
